// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"468":"7bca7254","488":"ad6e9feb","621":"14418a05"}[chunkId] + ".chunk.js";
};